import styled, { css } from 'styled-components';
import { AiOutlineClose } from 'react-icons/ai';
import {
  flexBoxCenter,
  ItemBackground,
  ItemBackgroundDisable,
  justifyContentSpaceBetween,
} from '../styles/commonStyles';

import PartNumberSelect from './PartNumberSelect';

const ROW_HEIGHT = '30px';

const describe = (spec) =>
  spec?.partNumber
    ? `${spec.elementName} - ${spec.partNumber} / ${spec.current}a / ${spec.wattage}w / ${spec.voltage}v / ${spec.lengths}m - ${spec.lengths}ft`
    : 'element not found';

const MobileHeaterRow = ({
  partNumber,
  spec,
  isEnable,
  isLocked,
  options,
  onChange,
  onRemove,
}) => (
  <MobileWrapper isEnable={isEnable}>
    <MobileTopRow>
      <MobilePartNumber isEnable={isEnable}>
        <PartNumberSelect
          value={partNumber}
          options={options}
          isEnable={isEnable}
          isLocked={isLocked}
          onChange={onChange}
        />
      </MobilePartNumber>

      {!isLocked && onRemove && (
        <RemoveButton
          type='button'
          aria-label={`remove ${partNumber || 'heater'}`}
          onClick={onRemove}
        >
          <AiOutlineClose />
        </RemoveButton>
      )}
    </MobileTopRow>

    <MobileFigures>
      <MobileFigure isEnable={isEnable}>
        <MobileFigureLabel>a</MobileFigureLabel>
        <ItemData>{spec?.current ? spec.current : '----'}</ItemData>
      </MobileFigure>
      <MobileFigure isEnable={isEnable}>
        <MobileFigureLabel>w</MobileFigureLabel>
        <ItemData>{spec?.wattage ? spec.wattage : '----'}</ItemData>
      </MobileFigure>
      <MobileFigure isEnable={isEnable}>
        <MobileFigureLabel>v</MobileFigureLabel>
        <ItemData>{spec?.voltage ? spec.voltage : '----'}</ItemData>
      </MobileFigure>
      <MobileFigure isEnable={isEnable}>
        <MobileFigureLabel>ft</MobileFigureLabel>
        <ItemData>{spec?.lengths ? spec.lengths : '----'}</ItemData>
      </MobileFigure>
    </MobileFigures>

    <MobileDescription isEnable={isEnable}>
      <ItemDataDescription isEnable={isEnable}>
        {describe(spec)}
      </ItemDataDescription>
    </MobileDescription>
  </MobileWrapper>
);

const HeaterRow = ({
  partNumber,
  spec,
  isEnable = true,
  isLocked = false,
  options = [],
  onChange,
  onRemove,
  isMobile = false,
}) =>
  isMobile ? (
    <MobileHeaterRow
      partNumber={partNumber}
      spec={spec}
      isEnable={isEnable}
      isLocked={isLocked}
      options={options}
      onChange={onChange}
      onRemove={onRemove}
    />
  ) : (
  <ItemWrapper>
    <ItemPartNumber isEnable={isEnable}>
      <PartNumberSelect
        value={partNumber}
        options={options}
        isEnable={isEnable}
        isLocked={isLocked}
        onChange={onChange}
      />
    </ItemPartNumber>

    <ItemOuterWrapper isEnable={isEnable}>
      <ItemData>{spec?.current ? spec.current : '----'}</ItemData>
    </ItemOuterWrapper>
    <ItemOuterWrapper isEnable={isEnable}>
      <ItemData>{spec?.wattage ? spec.wattage : '----'}</ItemData>
    </ItemOuterWrapper>
    <ItemOuterWrapper isEnable={isEnable}>
      <ItemData>{spec?.voltage ? spec.voltage : '----'}</ItemData>
    </ItemOuterWrapper>
    <ItemOuterWrapper isEnable={isEnable}>
      <ItemData>{spec?.lengths ? spec.lengths : '----'}</ItemData>
    </ItemOuterWrapper>

    <DescriptionAndButtonWrapper>
      <ItemDescription isEnable={isEnable}>
        <ItemDataDescription isEnable={isEnable}>
          {describe(spec)}
        </ItemDataDescription>
      </ItemDescription>

      {!isLocked && onRemove && (
        <RemoveButton
          type='button'
          aria-label={`remove ${partNumber || 'heater'}`}
          onClick={onRemove}
        >
          <AiOutlineClose />
        </RemoveButton>
      )}
    </DescriptionAndButtonWrapper>
  </ItemWrapper>
);

export default HeaterRow;

const MobileWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 4px 3px;
  margin-bottom: 4px;
  border-radius: 10px;
  ${ItemBackground}

  ${(p) =>
    p.isEnable ||
    css`
      ${ItemBackgroundDisable}
    `}
`;

const MobileTopRow = styled.div`
  width: 100%;
  ${justifyContentSpaceBetween}
  gap: 4px;
`;

const MobilePartNumber = styled.li`
  flex: 1;
  min-width: 0;
  height: ${ROW_HEIGHT};
  ${ItemBackground}
  ${flexBoxCenter}

  ${(p) =>
    p.isEnable ||
    css`
      ${ItemBackgroundDisable}
    `}
`;

const MobileFigures = styled.div`
  width: 100%;
  display: flex;
  gap: 3px;
`;

const MobileFigure = styled.li`
  flex: 1;
  min-width: 0;
  height: 20px;
  ${flexBoxCenter}
  gap: 3px;
  ${ItemBackground}

  ${(p) =>
    p.isEnable ||
    css`
      ${ItemBackgroundDisable}
    `}

  > div {
    width: auto;
    font-size: 9px;
  }
`;

const MobileFigureLabel = styled.span`
  font-size: 8px;
  color: #95ff45;
`;

const MobileDescription = styled.li`
  width: 100%;
  min-height: 20px;
  padding: 2px;
  ${flexBoxCenter}
  ${ItemBackground}

  ${(p) =>
    p.isEnable ||
    css`
      ${ItemBackgroundDisable}
    `}
`;

const ItemWrapper = styled.div`
  ${flexBoxCenter}
  justify-content: space-between;
  padding: 0 1.5px;
  margin-bottom: 3px;
`;

const ItemPartNumber = styled.li`
  width: 94px;
  height: ${ROW_HEIGHT};
  ${ItemBackground}
  ${flexBoxCenter}

  ${(p) =>
    p.isEnable ||
    css`
      ${ItemBackgroundDisable}
    `}
`;

const ItemOuterWrapper = styled.li`
  ${flexBoxCenter}
  width: 96px;
  height: ${ROW_HEIGHT};
  ${ItemBackground}

  ${(p) =>
    p.isEnable ||
    css`
      ${ItemBackgroundDisable}
    `}
`;

const ItemData = styled.div`
  font-size: 10px;
  text-align: center;
  width: 90px;
  background-color: transparent;
`;

const ItemDescription = styled.li`
  ${flexBoxCenter}
  width: 385.5px;
  height: ${ROW_HEIGHT};
  ${ItemBackground}
  ${(p) =>
    p.isEnable ||
    css`
      ${ItemBackgroundDisable}
    `};
`;

const ItemDataDescription = styled.span`
  font-size: 7.5px;
  text-align: center;
  width: 90%;
  letter-spacing: -0.2px;
  color: ${(p) => p.isEnable || `#808080;`};
  margin-right: 6px;
`;

const DescriptionAndButtonWrapper = styled.div`
  width: 408px;
  ${justifyContentSpaceBetween}
`;

const RemoveButton = styled.button`
  width: 20px;
  height: 20px;
  ${flexBoxCenter}

  background-color: transparent;
  border: none;
  border-radius: 50%;
  color: #808080;
  font-size: 11px;
  cursor: pointer;

  &:hover {
    color: #ff7800;
    background-color: hsla(0deg, 0%, 100%, 0.08);
  }
`;
